import React, { useState } from "react";
import AlertPopupModal from "../modules/Common/AlertPopupModal.jsx";
import NotificationMessage from "../modules/Common/NotificationMessage.jsx";

export const ORANGE_POPUP_CODES = new Set([
  405, 406, 407, 409, 410, 413, 414, 416, 418, 420, 421, 422, 423, 424, 425,
  427, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 443, 447,
  449, 450, 451, 452, 453, 456, 457, 458, 460, 467, 469, 472, 474, 478, 479,
  483, 484, 10009, 485, 486, 487, 488, 489, 492, 493, 496, 497, 498, 499,
  601, 602, 603, 604, 605, 606, 607
  //, 444
]);

export const useApiUiResponse = (t) => {
  const [notification, setNotification] = useState(null);
  const [showApiAlertPopup, setShowApiAlertPopup] = useState(false);
  const [apiAlertPopupData, setApiAlertPopupData] = useState({
    title: t("react_attention"),
    message: "",
    onConfirm: null,
    code: null
  });

  const redirectToLogin = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleApiUiResponse = (
    response,
    {
      successToaster = 1,
      errorToaster = 1,
      alertPopup = 1,
      onConfirmByCode = {}
    } = {}
  ) => {
    const data = response?.Data;

    if (!data) return;

    // Skip UI handling for specific response code =1555 - https://staging.ronspot.ie/api/v5/MakeBooking_api/BookingStatus
    const code = Number(data.ResponseCode);
    if (code === 1555) return;

    const successMessage =
      data.SuccessMessage && data.SuccessMessage.trim() !== ""
        ? data.SuccessMessage
        :  t("react_success_operation") || data.Message ;
    const responseMessage =
      data.ErrorMessage && data.ErrorMessage.trim() !== ""
        ? data.ErrorMessage
        : data.Message || t("react_error_operation");

    if (code === 200) {
      if (successToaster === 1) {
        setNotification({
          type: "success",
          title: t("success"),
          message:  successMessage
        });
      }
      return;
    }

    if (ORANGE_POPUP_CODES.has(code)) {
      if (alertPopup === 1) {
        const customConfirm = onConfirmByCode?.[code];
        setApiAlertPopupData({
          title: t("react_attention"),
          message: responseMessage,
          code,
          onConfirm: customConfirm
            ? () => {
                setShowApiAlertPopup(false);
                setApiAlertPopupData({
                  title: t("react_attention"),
                  message: "",
                  onConfirm: null,
                  code: null
                });
                customConfirm();
              }
            : (code === 423
                ? redirectToLogin
                : null)
        });
        setShowApiAlertPopup(true);
      }
      return;
    }

    if (errorToaster === 1) {
      setNotification({
        type: "error",
        title: t("fail"),
        message: responseMessage
      });
    }
  };

  const renderApiUi = (isLoading = false) => (
    <>
      {showApiAlertPopup && (
        <AlertPopupModal
          title={apiAlertPopupData?.title}
          message={apiAlertPopupData?.message}
          onConfirm={apiAlertPopupData?.onConfirm}
          onClose={() => {
            const shouldRedirectToLogin = apiAlertPopupData?.code === 423;

            setShowApiAlertPopup(false);
            setApiAlertPopupData({
              title: t("react_attention"),
              message: "",
              onConfirm: null,
              code: null
            });

            if (shouldRedirectToLogin) {
              redirectToLogin();
            }
          }}
        />
      )}

      {notification && !isLoading && (
        <NotificationMessage
          type={notification.type}
          title={notification.title}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </>
  );

  return {
    handleApiUiResponse,
    renderApiUi
  };
};
